// extracted by mini-css-extract-plugin
module.exports =  {"secondary":"ButtonSecondary-module__secondary___xYgPk"};